var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecoEngineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#DDE5ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9496 11.0784C18.0029 12.0916 21.2325 16.0536 22.1631 19.9274C22.3586 20.7451 22.4357 21.4913 22.4109 22.152L28 15.803C22.1796 9.48705 15.2469 7.14127 12.2073 10.5939C11.6704 11.2023 11.2905 11.954 11.0564 12.8157C11.5575 11.161 12.9755 10.4204 14.9496 11.0784Z",
    fill: "#004B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9932 19.8118C18.2289 19.8118 20.0433 18.0001 20.0433 15.7618C20.0433 13.5234 18.2316 11.7117 15.9932 11.7117C13.7548 11.7117 11.9432 13.5234 11.9432 15.7618C11.9432 18.0001 13.7548 19.8118 15.9932 19.8118Z",
    fill: "#00DCCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0477 20.489C13.9943 19.4758 10.7648 15.5138 9.83415 11.64C9.63867 10.8223 9.56158 10.0761 9.58636 9.41537L4 15.7644C9.81763 22.0804 16.7503 24.4289 19.7899 20.9735C20.3268 20.3651 20.7068 19.6134 20.9408 18.7517C20.4397 20.4064 19.0245 21.147 17.0477 20.489Z",
    fill: "#004B8B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoEngineIcon);
export default __webpack_public_path__ + "static/media/reco-engine-icon.f0a84f41e102c955f559ef5706852470.svg";
export { ForwardRef as ReactComponent };